import { httpClient } from './api/httpClient';
import { isMockEnabled } from './api/mockAdapter';
import { API_ENDPOINTS } from 'constants/apiEndpoints';

const _DEFAULTS = {
  articleHistoryDays: 40,
  notificationDays: 5,
  notificationsPerDay: 2,
  notificationTimes: ['09:00', '17:00'],
  notificationStatus: 'inactive',
  updatedAt: null,
  updatedBy: null,
};

export const toSystemConfig = (raw) =>
  raw && {
    articleHistoryDays: raw.article_history_days ?? raw.articleHistoryDays ?? 40,
    notificationDays: raw.notification_days ?? raw.notificationDays ?? 5,
    notificationsPerDay: raw.notifications_per_day ?? raw.notificationsPerDay ?? 2,
    notificationTimes: raw.notification_times ?? raw.notificationTimes ?? ['09:00', '17:00'],
    notificationStatus: raw.notification_status ?? raw.notificationStatus ?? 'inactive',
    updatedAt: raw.updated_at ?? raw.updatedAt ?? null,
    updatedBy: raw.updated_by ?? raw.updatedBy ?? null,
  };

const toPayload = (model) => ({
  article_history_days: Number(model.articleHistoryDays),
  notification_days: Number(model.notificationDays),
  notifications_per_day: Number(model.notificationsPerDay),
  notification_times: model.notificationTimes,
  notification_status: model.notificationStatus,
});

let _mockConfig = { ..._DEFAULTS };

export const systemConfigService = {
  async get() {
    if (isMockEnabled()) return { ..._mockConfig };
    const raw = await httpClient.get(API_ENDPOINTS.SETTINGS.SYSTEM_CONFIG);
    return toSystemConfig(raw);
  },

  async upsert(model) {
    if (isMockEnabled()) {
      _mockConfig = { ...model };
      return { ..._mockConfig };
    }
    const raw = await httpClient.put(API_ENDPOINTS.SETTINGS.SYSTEM_CONFIG, toPayload(model));
    return toSystemConfig(raw);
  },
};

export default systemConfigService;
